import React, { useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import AnimatedWrapper from '../components/AnimatedWrapper';
import ProgressBar from "../components/ProgressBar";
import SmoothSkinGraph from "../components/Animations/animation26";
import amplitude from "../utils/amplitude";

export default function Page26() {
  const navigate = useNavigate();

  // Хук для установки CSS-переменной --vh при загрузке и изменении размера
  useEffect(() => {
    function setVh() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

        if(process.env.NODE_ENV === "production"){
              amplitude.track('Quiz Step Open', {
            step_number: 26,
          });
            }
    setVh();
    window.addEventListener('resize', setVh);
    return () => window.removeEventListener('resize', setVh);
  }, []);

  const nextStep = () => {
    if(process.env.NODE_ENV === "production"){
      amplitude.track('Quiz Step Complete', {
        step_number: 26,
        answers: ""
      });

    }
    navigate('/quiz27');
  };

  const stepBack = () => {
    navigate('/quiz25');
  };

  return (
  <AnimatedWrapper>
      <div
        className="flex flex-col px-4"
        style={{ height: 'calc(var(--vh, 1vh) * 100)' }}
      >
        {/* Верхняя панель */}
        <div className="flex items-center space-x-2 p-4 mb-1">
          <button className="text-gray-600" onClick={stepBack}>
            <IoIosArrowBack size={24} />
          </button>
          <ProgressBar />
        </div>

        {/* График и текст идут подряд */}
        <div className="flex-grow">
          <SmoothSkinGraph />
          <h2 className="text-xl font-semibold leading-snug text-center mt-6">
            Your treatment program is a<br />
            93% fit to your skin by<br />
            knowing you better
          </h2>
        </div>

        {/* Кнопка прижата к низу */}
        <div className="w-full mb-2 flex justify-center">
          <button
            className="bg-pinkCustom text-white w-full max-w-xs py-3 rounded-full font-semibold hover:bg-pinkCustom transition"
            onClick={nextStep}
          >
            Let's make it 100%!
          </button>
        </div>
      </div>
    </AnimatedWrapper>  
  );
}
